import React, {useEffect, useState} from "react";
import {DataTable, Modal, P, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../../types/CustomerDTO";
import CustomerService from "../../services/CustomerService";
import { ProjectAccents } from "../../../General/config/projectAccents";

interface DbSize {
    databaseType: string;
    databaseName: string;
    sizeMb: number;
}

function DbSizes(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function }) {

    const [loading, setLoading] = useState<boolean>(false);
    const [dbSizes, setDbSizes] = useState<DbSize[]>([]);

    useEffect(() => {
        setLoading(true);
        CustomerService.getDbSize(props.selectedCustomer.clientId, props.selectedCustomer.corpSite)
            .then((e) => {
                setDbSizes(e ? [e] : []);
                setLoading(false);
            })
            .catch(() => {
                setDbSizes([]);
                setLoading(false);
            });
    }, []);

    const columns = React.useMemo(
        () => [
            { accessorKey: 'databaseType', header: 'Database' },
            { accessorKey: 'databaseName', header: 'Name' },
            { accessorKey: 'sizeMb', header: 'Size (MB)' }
        ],
        [],
    );

    const renderModalContent = () => {
        if (loading) {
            return <Spinner />;
        }
        return (
            <DataTable
                columns={columns}
                data={dbSizes}
                noDataElement={<P>Sorry, there is no DB size data available.</P>}
            />
        )
    }

    let content;
    content =
        <Modal
            visible={props.visible}
            accent={ProjectAccents.CareCompliance}
            heading={`DB Sizes`}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>

    return (
        <>
            {content}
        </>
    )

}

export default DbSizes;
